import React, {forwardRef} from "react";
import {Accordion, Button, Card} from "react-bootstrap";

const AccordionItem = forwardRef(({
                                      title,
                                      eventKey,
                                      activeKey,
                                      enable = true,
                                      completed,
                                      children,
                                      asButton = false,
                                      onEntered,
                                      completable
                                  }, ref) => {
    return (
        <div ref={ref}>
            <Card className={"shadow "}>
                <Card.Header>
                    {asButton ?
                        <Accordion.Toggle as={Button}
                                          className={"accordion-button"}
                                          variant="outline-primary"
                                          disabled={!enable}
                                          eventKey={eventKey}>
                            {completable &&
                                <span className={"h4 mr-3"}>
                                        {completed ?
                                            <i className="far fa-check-circle text-primary"></i> :
                                            <i className="far fa-times-circle text-secondary"></i>
                                        }
                               </span>

                            }
                            <span className={"h6 ali"}>{title}</span>

                        </Accordion.Toggle>
                        :
                        <strong>
                            <div className="float-left pt-2">
                                {title}
                            </div>
                        </strong>
                    }
                    <div className={"float-right"}>
                        <Accordion.Toggle as={Button}
                                          className={"accordion-button"}
                                          variant="outline-primary"
                                          disabled={!enable}
                                          eventKey={eventKey}>
                            {eventKey === activeKey ?
                                <i className="fas fa-chevron-circle-up text-primary h5"></i> :
                                <i className="fas fa-chevron-circle-down text-primary h5"></i>
                            }
                        </Accordion.Toggle>
                    </div>
                </Card.Header>
            </Card>
            <Accordion.Collapse eventKey={eventKey} onEntered={onEntered} className={"mt-3"}>
                {children}
            </Accordion.Collapse>
        </div>
    );
});

export default AccordionItem;
